import { store } from "./stores"
import { authClient } from "@/lib/auth-client"
import { toast } from "sonner"
import { User } from "./user.store"

// interface WorkspaceSession extends User { }

// interface LoginResponse {
//   user?: User
//   workspaces?: WorkspaceSession[]
// }

interface Workspace {
  id: string
  name: string
  slug: string
  avatar: string
  created_at: string
  updated_at: string
}

interface WorkspaceSession extends Workspace {
  token: string
}

// type AuthSession = NonNullable<ReturnType<typeof authClient.useSession>['data']>
// type WorkspaceSession = NonNullable<ReturnType<typeof authClient.useActiveOrganization>['data']>

export interface Session { //extends LoginResponse {
  // session?: AuthSession['session'] | null
  // user?: AuthSession['user'] | null
  // workspace?: WorkspaceSession
  // authSession?: {
  //   session: {
  //     id: string;
  //     createdAt: Date;
  //     updatedAt: Date;
  //     userId: string;
  //     expiresAt: Date;
  //     token: string;
  //     ipAddress?: string | null | undefined;
  //     userAgent?: string | null | undefined;
  //   }
  //   user: {
  //     id: string;
  //     email: string;
  //     emailVerified: boolean;
  //     name: string;
  //     createdAt: Date;
  //     updatedAt: Date;
  //     image?: string | null | undefined;
  //   }
  // } | null
  user?: User
  currentWorkspace?: WorkspaceSession | null
  register?: {
    email?: string
  }

  // Actions
  actions: {
    login: (dto: { email: string; password: string }) => Promise<void>
    updateAccount: (dto: Partial<{ name: string; image: string }>) => Promise<void>
    changePassword: (dto: { currentPassword: string; newPassword: string }) => Promise<void>
    logout: () => void
    // saveAuthSession: (authSession: AuthSession) => void
    saveCurrentWorkspace: (workspace: WorkspaceSession) => void
    saveKinboxAuthSession: (authSession: {
      workspace: WorkspaceSession
      user: User
    }) => void
  }
}

export const sessionStore: Session = {
  ...(JSON.parse(localStorage.getItem("session") as any) || {}),
  // register: JSON.parse(localStorage.getItem("register") as any || "{}"),
  register: {},
  actions: {
    saveKinboxAuthSession: (authSession) => {
      console.log("authSession", authSession)
      store.session = {
        ...store.session,
        currentWorkspace: authSession.workspace,
        user: authSession.user,
      }
    },
    // saveAuthSession: (authSession) => {
    //   store.session = {
    //     ...store.session,
    //     session: authSession.session,
    //     user: authSession.user,
    //   }
    // },
    // saveCurrentWorkspace: (workspace) => {
    //   store.session = {
    //     ...store.session,
    //     workspace,
    //   }
    // },
    // login: async (dto) => {
    //   const response = await client.post<LoginResponse>(endpoints.LOGIN, dto)
    //   if (response.data?.workspaces?.length) {
    //     store.session = {
    //       ...response.data,
    //       currentWorkspace: response.data.workspaces[0],
    //       actions: store.session.actions,
    //     }
    //   }
    // },
    logout: () => {
      localStorage.clear()
      store.session = {
        actions: store.session.actions,
      }
      // authClient.signOut()
    },
    updateAccount: async (dto) => {
      return authClient.updateUser({
        ...(dto.name ? { name: dto.name } : {}),
        ...(dto.image ? { image: dto.image } : {}),
      }).then((res) => {
        if (res.error?.message) {
          toast.error(res.error.message)
          throw new Error(res.error.message)
        } else {
          toast.success("Profile has been updated.")
        }
      })
      // const response = await client.patch(endpoints.ACCOUNT, dto)
      // if (response.data) {
      //   store.session = { ...store.session, user: response.data }
      //   toast.success("Profile has been updated.")
      // }
    },
    changePassword: async (dto) => {
      return authClient.changePassword({
        newPassword: dto.newPassword,
        currentPassword: dto.currentPassword,
        revokeOtherSessions: true,
      }).then((res) => {
        if (res.error?.message) {
          toast.error(res.error.message)
          throw new Error(res.error.message)
        } else {
          toast.success("Password has been updated.")
        }
      })
      // await client.post(endpoints.ACCOUNT_CHANGE_PASSWORD, dto).then(() => {
      //   toast.success("Password has been updated.")
      // })
    },
    // patchLocalRegister: async (dto) => {
    //   const register = {
    //     ...store.session.register || {},
    //     ...dto
    //   }
    //   // localStorage.setItem("register", JSON.stringify(register))
    //   store.session.register = register
    // },
    // registerUserInfo: async (dto: { name: string; password: string }) => {
    //   return client.post(endpoints.REGISTER_USER_INFO, dto)
    // },
  },
}
